var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEyeIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.8 23.8",
    style: {
      enableBackground: "new 0 0 23.8 23.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C1C3C8;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,0L11.9,0c6.6,0,11.9,5.3,11.9,11.9l0,0c0,6.6-5.3,11.9-11.9,11.9l0,0C5.3,23.8,0,18.4,0,11.9l0,0 C0,5.3,5.3,0,11.9,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.3,11.9c-1.8-2-4.2-4.4-7.4-4.4c-1.3,0-2.5,0.4-3.8,1.2C7,9.4,6,10.3,4.5,11.8l0,0l0.3,0.3c2.1,2.2,4,4.1,7.2,4.1 c1.4,0,2.8-0.5,4.2-1.4c1.2-0.8,2.2-1.8,3-2.7L19.3,11.9L19.3,11.9z M11.9,15c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1 s3.1,1.4,3.1,3.1S13.6,15,11.9,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7,10.7c0-0.3,0.1-0.5,0.2-0.7c-1,0-1.9,0.8-1.9,1.9s0.8,1.9,1.9,1.9s1.9-0.8,1.9-1.9l0,0c-0.2,0.1-0.5,0.2-0.7,0.2 C12.3,12.1,11.7,11.5,11.7,10.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeIconCircle);
export default __webpack_public_path__ + "static/media/password_eye_icon_circle.2cafc115b38b0bac89f7f7732f5bebf3.svg";
export { ForwardRef as ReactComponent };